import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { StoreModule } from '@ngrx/store';
import * as fromProjectsReducer from 'libs/website/shell/src/lib/store/shell.reducer';
import * as fromSharedReducer from 'libs/website/shared/src/lib/store/shared.reducer';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from './_helper/interceptor.service';
import { UiMaterialModule } from '@takeoff-group/ui/material';
import { UiComponentsModule } from '@takeoff-group/ui/ui-components';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { ToastrModule } from 'ngx-toastr';
import { CanonicalTagsService } from './canonical-tags.service';
import { SlickCarouselModule } from 'ngx-slick-carousel';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    HttpClientModule,
    SlickCarouselModule,
    LoggerModule.forRoot({
      serverLoggingUrl: `${environment.config.api}/render-error`,
      level: NgxLoggerLevel.DEBUG,
      serverLogLevel: NgxLoggerLevel.ERROR
    }),
    AppRoutingModule,
    StoreModule.forRoot({
      websiteShell: fromProjectsReducer.WebsiteShellReducer,
      websiteShared: fromSharedReducer.WebsiteSharedReducer
    }),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production
    }),
    UiMaterialModule,
    UiComponentsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      closeButton: true
    })
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    CanonicalTagsService
  ]
})
export class AppModule {}
